
export {array,
bool,
func,
number,
object,
string,
symbol,
any,
arrayOf,
element,
elementType,
instanceOf,
node,
objectOf,
oneOf,
oneOfType,
shape,
exact,
checkPropTypes,
resetWarningCache,
PropTypes} from '../../../frontend-js-react-web/__liferay__/exports/prop-types.js';
import __x__ from '../../../frontend-js-react-web/__liferay__/exports/prop-types.js';export default __x__;